import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
// eslint-disable-next-line import/named
import { getMessageResult } from '../../../../apis/api/pointApi';
import { formatDateBase } from '@/shared/util/format/dateFormatUtil';
import dayjs from 'dayjs';
import { useMutationMessageExcelDown } from './useMessageResultExcel';

export const useMessageResult = () => {
  const pageSize: number = 10;

  const [totalPage, setTotalPage] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [startPage, setStartPage] = useState(1);

  const navigate = useNavigate();

  // 현재 날짜, 이전 달 첫 날짜 - 리스트 초기 요청값
  const initToday = dayjs(new Date()).format('YYYYMMDD');
  const initPrevMonth = dayjs().subtract(1, 'month').startOf('month').format('YYYYMMDD');

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initialPage = parseInt(searchParams.get('page') as string, 10) || 1;
  const initialDates = searchParams.get('searchDates')?.split(',') ?? [initPrevMonth, initToday];
  const initialSelectValue = searchParams.get('searchSelectValue');

  const [currentPage, setCurrentPage] = useState(initialPage);
  const [searchSelectValue, setSearchSelectValue] = useState<string | null>(initialSelectValue);
  const [searchDates, setSearchDates] = useState<string[] | string>(initialDates);

  const [selectMode, setSelectMode] = useState<string>('010');

  // 페이싱네이션 - 페이지 변경
  const handlePageChange = (pageNumber: any) => {
    navigate(`?page=${pageNumber}`);
    setCurrentPage(pageNumber);
  };
  useEffect(() => {
    navigate(`?page=${currentPage}&searchDates=${searchDates}&searchSelectValue=${searchSelectValue}`);
    setActivePage(currentPage);
  }, [searchDates, searchSelectValue, currentPage]);

  const thead = ['구분', '전송일시', '전송내용', '받는사람', '전송상태'];

  const {
    data: result010Data,
    isSuccess,
    isLoading,
  } = useQuery(['result010', currentPage, pageSize, searchDates, searchSelectValue, selectMode], () =>
    getMessageResult(currentPage - 1, pageSize, searchDates, searchSelectValue, selectMode).then((data) =>
      data.content.map((e: any, idx: number) => {
        return {
          id: e.prepayPayNo,
          callback: e.callback,
          구분: e.msgGb,
          전송일시: e.sndDttm,
          전송내용: e.sndMsg,
          받는사람: e.receiver,
          전송상태: e.status,
        };
      }, setTotalPage(data.totalElements)),
    ),
  );

  // useEffect(() => {
  //   getPointResult(currentPage - 1, pageSize, searchDates, searchSelectValue).then((data) =>
  //     setTotalPage(data.totalElements),
  //   );
  //   // handlePageChange(currentPage-1);
  // }, [currentPage]);

  const selectedValue = [
    { value: 'all', label: '전체조회' },
    { value: '00000', label: 'SMS' },
    { value: 'LMS01', label: 'LMS' },
    { value: 'MMS01', label: 'MMS' },
  ];

  // const selectedValue = [
  //   { value: 'all', label: '전체조회' },
  //   { value: '1', label: 'SMS' },
  //   { value: '2', label: 'LMS' },
  //   { value: '3', label: 'MMS' },
  // ];

  // 이전 달의 첫 번째 날짜 계산
  const lastMonthStart = dayjs().subtract(1, 'month').startOf('month');

  // 이번 달의 마지막 날짜 계산
  const currentMonthEnd = dayjs().endOf('month');

  const disabledDate = (current: any) => {
    return current < lastMonthStart || current > currentMonthEnd;
  };

  // 엑셀 다운
  const { isExcelLoading, mutationExcelDown } = useMutationMessageExcelDown({
    searchDates,
    searchSelectValue,
  });

  const excelDownload = () => {
    mutationExcelDown();
  };

  return {
    thead,
    result010Data,
    totalPage,
    handlePageChange,
    startPage,
    setStartPage,
    activePage,
    setActivePage,
    currentPage,
    setCurrentPage,
    selectedValue,
    disabledDate,
    setSearchSelectValue,
    searchDates,
    setSearchDates,
    isSuccess,
    excelDownload,
    mutationExcelDown,
    isExcelLoading,
    isLoading,
    setSelectMode,
  };
};

// export default usePointHistory;
